<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
    </teleport>
    <ModalFigli
        v-model:visible="visible"
        @add="addFiglio"
    ></ModalFigli>
    <div class="m-auto max-w-screen-2xl px-20 pb-8">
        <div class="py-10 flex justify-between">
            <Breadcrumbs :paths="paths"></Breadcrumbs>
            <div class="flex">
                <NextButton variant="outline-secondary" @click="$router.back()"
                            class="w-48 hidden text-sm sm:block py-2 px-4">
                    &lt; Indietro
                </NextButton>
                <NextButton variant="primary" component="router-link" :to="{name: 'FormContatto'}"
                            class="w-48 ml-3 text-sm py-2 px-4 m-0 hidden sm:block">
                    + Aggiungi Contatto
                </NextButton>
            </div>
        </div>
        <h3 class="text-3xl font-bold mb-3">Dettaglio contatto</h3>
        <Alert v-if="permission_denied" class="bg-next-orange mb-5 sticky top-0 z-50">Non hai i permessi sufficienti per poter creare
            un contatto
        </Alert>
        <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
            <div class="lg:col-span-2">
                <div class="grid lg:grid-cols-2 gap-3">
                    <div class="flex flex-col mb-3">
                        <Field field_name="Nome" :required="true" v-model="contatto_model.nome"
                               :errors="getErrors('nome')"></Field>
                    </div>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Cognome" :required="true" v-model="contatto_model.cognome"
                               :errors="getErrors('cognome')"></Field>
                    </div>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Posizione lavorativa" :required="true"
                               v-model="contatto_model.posizione_lavorativa"
                               :errors="getErrors('posizione_lavorativa')"></Field>
                    </div>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Dipartimento" v-model="contatto_model.dipartimento"
                               :errors="getErrors('dipartimento')"></Field>
                    </div>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Indirizzo email" :required="true" v-model="contatto_model.email"
                               :errors="getErrors('email')"></Field>
                    </div>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Metodo di contatto preferito" v-model="contatto_model.contatto_predefinito"
                               :errors="getErrors('contatto_predefinito')"></Field>
                    </div>
                    <div class="flex flex-col pb-3 lg:border-b border-next-gray-md-dark">
                        <Field field_name="Numeri di telefono" :required="false"
                               v-model="contatto_model.telefono_1"
                               :errors="getErrors('telefono_1')">
                            <div class="grid grid-cols-4 gap-3">
                                <input v-model="contatto_model.telefono_1" placeholder="Numero telefono"
                                       class="col-span-3 p-2 bg-next-gray-md-dark hover:bg-white">
                                <a :href="`tel:${contatto_model.telefono_1}`"
                                   class="flex justify-center items-center bg-next-gray-md-dark">
                                    <i class="icon-telefono p-3"></i></a>
                            </div>
                        </Field>
                    </div>

                    <div class="flex flex-col pb-3 lg:border-b border-next-gray-md-dark">
                        <Field field_name="Numeri di telefono" :required="false" label-class="invisible"
                               v-model="contatto_model.telefono_2"
                               :errors="getErrors('telefono_2')">
                            <div class="grid grid-cols-4 gap-3">
                                <input v-model="contatto_model.telefono_2" placeholder="Numero telefono"
                                       class="col-span-3 p-2 bg-next-gray-md-dark hover:bg-white">
                                <a :href="`tel:${contatto_model.telefono_2}`"
                                   class="flex justify-center items-center bg-next-gray-md-dark">
                                    <i class="icon-telefono p-3"></i></a>
                            </div>
                        </Field>
                    </div>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Gruppo di appartenenza" :required="true"
                               v-model="gruppoAutocomplete.selection"
                               :errors="getErrors('gruppo_contatti_id')">
                            <VueMultiselect @search-change="gruppoAutocomplete.search"
                                            :loading="gruppoAutocomplete.isLoading"
                                            :options="gruppoAutocomplete.options"
                                            v-model="gruppoAutocomplete.selection"
                                            track-by="id" label="nome"
                                            placeholder="Gruppo"
                                            deselectLabel="Deseleziona"
                                            selectedLabel="Selezionato"
                                            selectLabel="Seleziona"
                                            tagPlaceholder="Aggiungi gruppo"
                                            class="next-vue-multiselect-single ">
                                <template v-slot:noResult>Nessun elemento trovato.</template>
                            </VueMultiselect>
                        </Field>
                    </div>
                    <div class="flex flex-col pb-3 lg:border-b border-next-gray-md-dark">
                        <Field field_name="Account" :required="false"
                               v-model="accountAutocomplete.selection"
                               :errors="getErrors('accounts')">
                            <VueMultiselect v-model="accountAutocomplete.selection"
                                            :options="accountAutocomplete.options"
                                            :multiple="true"
                                            @search-change="accountAutocomplete.search"
                                            :close-on-select="false" :clear-on-select="false"
                                            placeholder="Accounts"
                                            deselectLabel="Deseleziona"
                                            selectedLabel="Selezionato"
                                            selectLabel="Seleziona"
                                            tagPlaceholder="Aggiungi account"
                                            class="next-vue-multiselect"
                                            track-by="id" label="name">
                                <template v-slot:noResult>Nessun elemento trovato.</template>
                                <template v-slot:tag="{option, remove}">
                                    <MultiselectOption @remove="remove(option)">
                                        <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                            {{ option.bu_label || '&nbsp;' }}</span>
                                        <span>{{ option.name }}</span>
                                    </MultiselectOption>
                                </template>

                                <template v-slot:option="{option}">
                                        <span>
                                            <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                            <span class="ml-2">{{ option.name }}</span>
                                        </span>
                                </template>
                            </VueMultiselect>
                        </Field>
                    </div>
                </div>
            </div>
            <div class="xl:col-span-1 lg:col-span-2 flex flex-col pb-3 lg:border-b border-next-gray-md-dark">
                <Field field_name="Note" :required="false">
                    <textarea v-model="contatto_model.note" placeholder="Note"
                              class="flex-grow p-5 bg-white"/>
                </Field>
            </div>

            <div class="grid grid-cols-3 col-span-2 gap-4">
                <div class="flex flex-col pb-3">
                    <Field field_name="Data di nascita" v-model="contatto_model.data_di_nascita" type="date"
                           placeholder="Data di nascita"
                           :errors="getErrors('anni_in_azienda')">
                    </Field>
                </div>
                <div class="flex flex-col pb-3">
                    <Field field_name="Data ingresso in azienda" v-model="contatto_model.data_ingresso_in_azienda"
                           type="date" placeholder="Data ingresso in azienda"
                           :errors="getErrors('data_ingresso_in_azienda')">
                    </Field>
                </div>
                <div class="flex flex-col pb-3">
                    <Field field_name="Presente in azienda"
                           :errors="getErrors('presente')">
                        <Checkbox
                            checkClass="h-4 w-4"
                            :checked="contatto_model.presente"
                            @change="contatto_model.presente = !contatto_model.presente"
                            for_id="pm_esterno">
                        </Checkbox>
                    </Field>
                </div>
            </div>

            <div class="flex flex-col pb-3">
                <Field field_name="Stato civile" v-model="contatto_model.stato_civile" placeholder="Stato civile"
                       :errors="getErrors('stato_civile')">
                </Field>
            </div>

            <!--                    <div class="flex flex-col mb-3">-->
            <!--                        <div class="flex justify-start items-center pb-2 text-sm">-->
            <!--                            <div class="font-bold">Figli</div>-->
            <!--                            <i @click="modalAddFigli" class="cursor-pointer icon-croce_cerchiata text-2xl pl-3"></i>-->
            <!--                        </div>-->
            <!--                        <div class="grid grid-cols-2 gap-3">-->
            <!--                            <div v-for="(f,i) in contatto_model.figli" :key="i"-->
            <!--                                 class="flex items-center bg-next-gray-md p-2 group border border-next-gray-md hover:border-next-orange hover:bg-white">-->
            <!--                                <span class="flex-grow">{{ `${f.sesso} / ${f.eta} / ${f.nome}` }}</span>-->
            <!--                                <i tabindex="1" @click.stop.prevent="removeFiglio(i)"-->
            <!--                                   class="cursor-pointer fa fa-times text-next-gray-md group-hover:text-next-orange p-0"></i>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </div>-->

            <div class="flex flex-col mb-3">
                <div class="font-bold pb-2 text-sm">Hobbies e Interessi</div>
                <VueMultiselect v-model="hobbiesAutocomplete.selection"
                                :options="hobbiesAutocomplete.options"
                                :multiple="true"
                                :taggable="true"
                                @tag="(value)=>hobbiesAutocomplete.add({id:-1, nome:value})"
                                @search-change="hobbiesAutocomplete.search"
                                :close-on-select="false" :clear-on-select="false"
                                class="next-vue-multiselect"
                                track-by="id" label="nome"
                                placeholder="Hobby"
                                deselectLabel="Deseleziona"
                                selectedLabel="Selezionato"
                                selectLabel="Seleziona"
                                tagPlaceholder="Aggiungi hobby">

                    <template v-slot:tag="{option, remove}">
                        <MultiselectOption @remove="remove(option)">{{ option.nome }}
                        </MultiselectOption>
                    </template>
                </VueMultiselect>
                <small v-for="(e,i) in getErrors('hobbies')" :key="i"
                       class="text-next-orange">{{ e }}</small>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import contattiManager from "../api/Contatti";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import Autocomplete from "@/setup/Autocomplete";
import hobbiesManager from "../api/Hobbies";
import ModalFigli from "@/components/ModalFigli.vue";
import gruppiContattiManager from "../api/GruppiContatti";
import NextEditor from "@/components/NextEditor.vue";
import Loading from "@/components/Loading.vue";
import userManager from "../api/Users";
import Alert from '@/components/Alert.vue';
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import Checkbox from "@/components/Checkbox.vue";

@Options({
    name: 'DettaglioContatto',
    components: {
        Checkbox,
        NextButton,
        Topbar,
        NextEditor,
        Breadcrumbs,
        ModalFigli,
        Loading,
        MultiselectOption,
        Field,
        Alert
    },

    props: {
        id: {
            type: [String, Number],
            required: true
        },
        cid: {
            type: [String, Number],
            required: true
        },
    }
})
export default class DettaglioContatto extends Vue {

    hobbiesAutocomplete: any = setup(() => Autocomplete(hobbiesManager, true))
    gruppoAutocomplete: any = setup(() => Autocomplete(gruppiContattiManager))
    accountAutocomplete: any = setup(() => Autocomplete(userManager, true))

    cid!: string | number
    id!: string | number
    visible = false
    loading = false
    permission_denied = false
    last_save: any | null = null

    contatto_model = {
        //serve per non far schiantare il link nel path nel caso scelga un id a cazzo
        azienda_id: 0,
        nome: null,
        cognome: null,
        dipartimento: null,
        posizione_lavorativa: null,
        stato_civile: null,
        data_ingresso_in_azienda: null,
        data_di_nascita: null,
        presente: true,
        email: null,
        figli: [] as any[],
        telefono_1: null,
        telefono_2: null,
        contatto_predefinito: null,
        gruppo_contatti_id: null,
        hobbies: [],
        users: [],
    }

    errors = {}

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    @Watch('hobbiesAutocomplete.selection', {deep: true})
    hobbies(new_value: any, old: any) {
        this.contatto_model.hobbies = new_value
    }

    @Watch('gruppoAutocomplete.selection', {deep: true})
    gruppo(new_value: any, old: any) {
        this.contatto_model.gruppo_contatti_id = new_value ? new_value.id : null
    }

    @Watch('accountAutocomplete.selection')
    account(new_value: any, old: any) {
        this.contatto_model.users = new_value.map((e: any) => e.id)
    }

    created() {
        this.loading = true
        Promise.all([contattiManager.contatto(this.cid).then((response) => {
            this.contatto_model = {...this.contatto_model, ...response.data}
            if (this.contatto_model.gruppo_contatti_id) {
                this.gruppoAutocomplete.retrieve(this.contatto_model.gruppo_contatti_id)
            }
        }).catch(() => {
        }),

            contattiManager.contattoHobbies(this.cid).then((response) => {
                this.hobbiesAutocomplete.options = response.data
                this.hobbiesAutocomplete.selection = response.data
            }),
            contattiManager.accounts(this.cid).then((response) => {
                this.accountAutocomplete.selection = response.data
                this.accountAutocomplete.options = response.data
            }),

            this.hobbiesAutocomplete.search('', 0),
            this.gruppoAutocomplete.search('', 0)
        ]).finally(() => {
            this.loading = false
        })
    }

    @Watch('contatto_model', {deep: true})
    debounceSave(old_val: any, new_val: any) {
        if (this.loading) return
        if (this.last_save) {
            clearTimeout(this.last_save)
            this.last_save = null
        }
        this.last_save = setTimeout(this.save, 1000)
    }

    save() {
        this.permission_denied = false
        contattiManager.contattiUpdate(this.cid, this.contatto_model).then((res) => {
            this.errors = {}
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
            }
            if (res.response.status == 403) {
                this.permission_denied = true
            }
        })
    }

    modalAddFigli() {
        this.visible = true
    }

    addFiglio(value: any) {
        this.contatto_model.figli.push(value)
    }

    removeFiglio(i: number) {
        this.contatto_model.figli.splice(i, 1)
    }

    get Name() {
        return this.contatto_model.nome
    }

    get paths() {
        return [
            {
                title: 'Home',
                name: 'Dashboard',
            },
            {
                title: 'Anagrafica',
                name: 'DettaglioAzienda',
                params: {id: this.id}
            },
            {
                title: 'Contatti',
                name: 'Contatti',
                params: {id: this.id}
            },
            {
                title: this.contatto_model.nome,
                name: 'DettaglioContatto',
                params: {id: this.id, cid: this.cid}
            },
        ]
    }

}
</script>


<style lang="scss">

</style>
